import { Route } from 'react-router-dom';

import BoardScreen from 'src/screens/board/board.component';
import BoardTechniciansScreen from 'src/screens/board-technicians/board-technicians.component';

import { PrivateRoute } from 'src/screens/app/routes/user/user.utils';

const boardRouteGroup = (
  <Route path="board">
    <Route index element={<PrivateRoute children={<BoardScreen />} />} />
    <Route
      path="technicians"
      element={<PrivateRoute children={<BoardTechniciansScreen />} />}
    />
  </Route>
);

export default boardRouteGroup;
